/**
 * 서버 응답 HTML 의 FE 측 최종 방어선.
 *
 * BE 어드민이 HtmlSanitizer 로 cleanup 한 HTML 을 내려주지만, 어드민 계정 탈취·BE 우회 입력 등으로
 * 변조된 HTML 이 내려오면 Capacitor WebView 특성상 XSS → 네이티브 브릿지까지 노출된다.
 * dangerouslySetInnerHTML 에 서버 데이터를 넣을 때는 반드시 이 함수를 거친다.
 *
 * 빌드타임 정적 자원(?raw import SVG 등)은 대상이 아니다.
 */
import DOMPurify from 'dompurify';

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
